<!-- El embudo no se pinta aquí: se presta a la cabecera, junto a la búsqueda (SearchService).
     Solo con panel: las tablas ya no ofrecen el menú clásico, y una tabla sin panel (sin filtros que ofrecer) no
     lleva embudo -->
<ng-template #embudo>
    <button mat-icon-button [matMenuTriggerFor]="propsMenu" class="embudo" matTooltip="Filtros"
            (menuOpened)="panelAbierto.emit()"
            *ngIf="panelFiltros?.length">
        <mat-icon fontSet="material-icons-outlined" [color]="withFilters ? 'warn' : ''">filter_alt</mat-icon>
        <span class="embudo-contador" *ngIf="panelFiltros && contadorPanel > 0">{{ contadorPanel }}</span>
    </button>
</ng-template>
<div class="menu">
    <mat-menu #propsMenu="matMenu">
        <be-panel-filtros *ngIf="panelFiltros"
                          [secciones]="panelFiltros"
                          [propiedades]="properties"
                          [filtros]="filtrosPanel"
                          (cambio)="aplicarPanel($event)"
                          (click)="$event.stopPropagation()"></be-panel-filtros>
        <!-- Con [hidden] y no *ngIf: este componente lee la lista con su @ViewChild estático en ngOnInit (con panel, vacía) -->
        <div [hidden]="!!panelFiltros">
            <be-filter-list #filterList (click)="$event.stopPropagation()"
                            [fixedFilteringProperties]="fixedFilteringProperties"></be-filter-list>
            <div class="botonera">
                <button mat-flat-button color="warn"
                        (click)="clearFilters()">Resetear
                </button>
                <button mat-flat-button color="primary"
                        (click)="applyFilters()">Aplicar
                </button>
            </div>
        </div>
    </mat-menu>
</div>
